module.exports = __webpack_public_path__ + "media/dialog_open.b4fea0f1.mp3";